import { createFileRoute } from '@tanstack/react-router';
import { AdminConnectedAppsPage } from '@/pages/super-admin/mcp/AdminConnectedAppsPage';

export const Route = createFileRoute('/_authenticated/super-admin/connected-apps')({
	component: AdminConnectedAppsPage,
});
